import { useEffect } from 'react';
import {useLoaderData} from 'react-router-dom';
import { making } from "../components/Header";

export function loader({params}) {
    const hyphen = params.work;
    return {hyphen};
}

export default function Making() {
    const {hyphen} = useLoaderData();
    const work = making.find((item) => item.hyphen === hyphen);
    
    window.scrollTo(0, 0);

    useEffect(() => {
        document.title = `rw - ${work.title}`;
    }, [work.title])

    return(
        <div id="making">
            {work?.items && 
                work.items.map((item) => {
                    if (item.type === "img") {
                        return (
                            <img src={`/making/${work.hyphen}/${item.ad} 1920.JPG`} alt={work.alt}/>
                        )
                    } else if (item.type === "link") {
                        return (
                            <a href={item.link} onClick={() => {window.open(this.href); return false;}}>{item.link}</a>
                        )
                    } else if (item.type === "text") {
                        return (
                            <p>{item.text}</p>
                        )
                    } 
                    return(<div/>);
                })
            }
        </div>
    )
}